export default __webpack_public_path__ + "static/media/Logo_WFClubAdmin.148f392e.svg";